import React from 'react';

import { addMonths, startOfDay, subMonths } from 'date-fns';
import DateRangeSelectionDropdown from 'screens/analytics/DateRangeSelectionDropdown';

import { TEAMHUB_PREDEFINED_DATERANGES } from 'constants/ProjectConstants';

import { buildDateFilters } from './helper';

const DUE_DATE_FILTER_UPDATE = 'DUE_DATE_FILTER_UPDATE';

export const initialDueDateFilterState = {};
export function dueDateFilterReducer(state = initialDueDateFilterState, action) {
  switch (action.type) {
    case DUE_DATE_FILTER_UPDATE: {
      return { ...action.filters, predefined: null };
    }
    default:
      return state;
  }
}

export const buildDueDateFilters = buildDateFilters('ACTIVE_CONTENT');

export default function NewDueDateFilter({
  selectedFiltersDispatch,
  selectedFilters = {},
  width = '20%',
  iconSize = 'tinyFixed',
}) {
  const updateDateRange = ({ startDate, endDate, label = '' }) => {
    selectedFiltersDispatch({
      type: DUE_DATE_FILTER_UPDATE,
      filters: { from: startDate, to: endDate, label },
    });
  };

  const widgetSupportedStructure = selectedFilters?.from
    ? {
        startDate: selectedFilters.from,
        endDate: selectedFilters.to,
        label: selectedFilters.label,
      }
    : {};

  return (
    <DateRangeSelectionDropdown
      dateRange={widgetSupportedStructure}
      onDateRangeChange={updateDateRange}
      predefinedRanges={TEAMHUB_PREDEFINED_DATERANGES}
      minDate={subMonths(startOfDay(new Date()), 11)}
      maxDate={addMonths(startOfDay(new Date()), 11)}
      clearable
      iconSize={iconSize}
    />
  );
}
